"use client";

import { useLocalizedQuery } from "@/hooks/locale/useLocalizeQuery/useLocalizeQuery";
import { ApiPage } from "@/api/page";

export const useAboutData = () => {
  const { data, isLoading } = useLocalizedQuery({
    queryKey: ["about"],
    queryFn: async lang => ApiPage.getAboutPage(lang),
  });

  return { data, isLoading };
};
